// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-box-showcase  .VertCarouselWithCustomNavigationArrow-navigations {
        width: 40px;
        height: 40px;
}
.CarouselBannersService.box {
    box-sizing: border-box;
}

.CarouselBannersService.row {
    box-sizing: border-box;
    height: 206px;
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
}

.CarouselBannersService.item {
    width: 33.333%;
    padding: 0 8px;
    box-sizing: border-box;
}

.CarouselBannersService.item figure {
    width: 100%;
    height: 206px;
    display: flex;
    margin: 0 auto;
    padding: 0;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 20px;
}

.CarouselBannersService.item figure img {
    height: 206px;
}

@media only screen and (max-width: 600px) {
    .CarouselBannersService.item {
        width: 100%;
    }

    .CarouselBannersService.row,
    .CarouselBannersService.item figure,
    .CarouselBannersService.item figure img{
        height: 127px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServicesBannersForHome/components/CarouselBannersService/style.css"],"names":[],"mappings":"AAAA;QACQ,WAAW;QACX,YAAY;AACpB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;;;QAGI,aAAa;IACjB;AACJ","sourcesContent":[".vert-box-showcase  .VertCarouselWithCustomNavigationArrow-navigations {\n        width: 40px;\n        height: 40px;\n}\n.CarouselBannersService.box {\n    box-sizing: border-box;\n}\n\n.CarouselBannersService.row {\n    box-sizing: border-box;\n    height: 206px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    margin: 0 auto;\n}\n\n.CarouselBannersService.item {\n    width: 33.333%;\n    padding: 0 8px;\n    box-sizing: border-box;\n}\n\n.CarouselBannersService.item figure {\n    width: 100%;\n    height: 206px;\n    display: flex;\n    margin: 0 auto;\n    padding: 0;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    border-radius: 20px;\n}\n\n.CarouselBannersService.item figure img {\n    height: 206px;\n}\n\n@media only screen and (max-width: 600px) {\n    .CarouselBannersService.item {\n        width: 100%;\n    }\n\n    .CarouselBannersService.row,\n    .CarouselBannersService.item figure,\n    .CarouselBannersService.item figure img{\n        height: 127px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
